import React, {useState, useEffect, useContext, useRef} from "react";
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {useHistory} from 'react-router-dom';
import {functions} from "../../constants/common-functions";
import {store} from '../../context/store';
import {NO_STRINGIFY} from "../../constants/general-constants";
import {JWT} from "../../constants/local-storage";
import CircularProgress from '@material-ui/core/CircularProgress';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_DATE} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import EditPanel from '../administration/components/EditPanel';
import {STRINGIFY} from "../../constants/general-constants";
import ClientCommercialContactPanel from '../administration/components/ClientCommercialContactPanel';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationClientCommercial(){
	const history = useHistory(); 
	const [displayProgress, setDisplayProgress] = useState("none");
	const [clientCommercial, setClientCommercial] = useState({});
	const [clientCommercialContacts, setClientCommercialContacts] = useState([]);
	
	const refContractStart = useRef(null);
	const refContractEnd = useRef(null);
	const refNumModels = useRef(null);
	const refNumScans = useRef(null);
	const refNumPhotoTours = useRef(null);
	const refMaxNumModels = useRef(null);
	const refMaxNumScans = useRef(null);
	const refMaxNumPhotoTours = useRef(null);
	const refComments = useRef(null);
	
	const mainComponentRows = [
		
		{ref:refContractStart, id:"1", title:"Contract Start", inputType:INPUT_TYPE_DATE},
		{ref:refContractEnd, id:"2", title:"Contract End", inputType:INPUT_TYPE_DATE},
		{ref:refNumModels, id:"3", title:"Number of Models", inputType:INPUT_TYPE_TEXT},
		{ref:refMaxNumModels, id:"4", title:"Max Number of Models", inputType:INPUT_TYPE_TEXT},
		{ref:refNumScans, id:"5", title:"Number of Scans", inputType:INPUT_TYPE_TEXT},
		{ref:refMaxNumScans, id:"6", title:"Max Number of Scans", inputType:INPUT_TYPE_TEXT},
		{ref:refNumPhotoTours, id:"7", title:"Number of Photo Tours", inputType:INPUT_TYPE_TEXT},
		{ref:refMaxNumPhotoTours, id:"8", title:"Max Number of Photo Tours", inputType:INPUT_TYPE_TEXT},
		{ref:refComments, id:"9", title:"Comments", inputType:INPUT_TYPE_TEXTAREA}
	];
	
	useEffect(() => {
		loadData();
	}, []);
	
	const loadData = () => {
		functions.getObjectFromAjax("/resolution/clientcommercial", null, populateForm);
		loadClientCommercialContacts();
	};
	
	const loadClientCommercialContacts = () => {
		functions.getArrayFromAjax("/resolution/clientcommercialcontacts", null, setClientCommercialContacts);
	};
	
	const populateForm = (clientCommercial) => {
		console.log(clientCommercial);
		try{
			refContractStart.current.value = functions.parseDateFromDatabase(clientCommercial.contractStart);
			refContractEnd.current.value = functions.parseDateFromDatabase(clientCommercial.contractEnd);
			refNumModels.current.value = clientCommercial.numModels;
			refNumScans.current.value = clientCommercial.numScans;
			refNumPhotoTours.current.value = clientCommercial.numPhotoTours;
			refMaxNumModels.current.value = clientCommercial.maxNumModels;
			refMaxNumScans.current.value = clientCommercial.maxNumScans;
			refMaxNumPhotoTours.current.value = clientCommercial.maxNumPhotoTours;
			refComments.current.value = clientCommercial.comments;
		}
		catch(e){alert(e)}
	};
	
	
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const mainTitle = {
		display:"flex",
		marginLeft:"20px",
		height:"60px",
		fontSize:"21px",
		alignItems:"center"	
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	const getSubmitObject = () => {
		
		let submitObject = {
			id:-100,
			contractStart:refContractStart.current.value,
			contractEnd:refContractEnd.current.value,
			numModels:refNumModels.current.value,
			numScans:refNumScans.current.value,
			numPhotoTours:refNumPhotoTours.current.value,
			maxNumModels:refMaxNumModels.current.value,
			maxNumScans:refMaxNumScans.current.value,
			maxNumPhotoTours:refMaxNumPhotoTours.current.value,
			comments:refComments.current.value
		};
		
		return submitObject;
	};
	
	const goSubmit = () => {
		setDisplayProgress("flex");
		functions.submitAjax("/resolution/clientcommercialsave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		alert(e);
		setDisplayProgress("none");
	};
	
	
	const saveEnd = () => {
		const timer = setTimeout(() => {setDisplayProgress("none");}, 1000);
	};
	
	const goBack = () => {
		history.push('/administrationhome');
	};
	
	const editFooter = {
		display:"flex",
		height:"80px",
		width:"calc(100% - 60px)",
		position:"fixed",
		bottom:"0px",
		left:"60px",
		backgroundColor:"black",
		justifyContent:"space-around",
		alignItems:'center'
	};
	
	const editButtonContainer = {
		display:"flex"
	};
	
	const editButton = {
		display:"flex",
		width:"200px",
		height:"40px",
		borderRadius:"4px",
		alignItems:"center",
		color:'white',
		fontSize:"14px",
		justifyContent:"space-around",
		cursor:'pointer',
		border:"1px solid " +DEFAULT_BLUE,
		margin:"5px"
	};
	
	const progressContainer = {
		display:displayProgress,
		width:"100%",
		height:"calc(100vh - 0px)",
		backgroundColor:"white",
		flexDirection:"column",
		zIndex:"2000",
		color:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		position:"fixed",
		top:"0px",
		left:"0px"
	};
	
	const contactContainer = {
		display:"flex",
		flexDirection:"column",
		width:"calc(50% - 40px)",
		marginLeft:"30px"
	};
	
	const contactHeader = {
		display:"flex",
		color:"black",
		height:"40px",
		alignItems:'center',
		paddingLeft:"10px",
		paddingRight:"5px",
		justifyContent:"space-between",
		borderRadius:"4px",
		color:"white",
		backgroundColor:"black",
		fontSize:"14px"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"30px",
		alignItems:"center",
		color:"white",
		backgroundColor:DEFAULT_BLUE,
		cursor:"pointer",
		justifyContent:"space-around",
		borderRadius:"4px",
		fontSize:"12px"
	};
	
	const addNew = () => {
		let tempContacts = [{
			id:-100,
			name:'',
			role:'',
			phone:'',
			email:'',
			location:'',
			comments:''	
		}];
		for(let i=0; i<clientCommercialContacts.length; i++){
			tempContacts.push(clientCommercialContacts[i]);
		}
		setClientCommercialContacts(tempContacts);
	};
	
	const clientCommercialContactDisplay = clientCommercialContacts.map((item, index) => 
		<ClientCommercialContactPanel
			id={item.id}
			clientCommercialContact={item}
			reloadFunction={loadClientCommercialContacts}
		/>
	);
	
	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
					<div style={mainTitle}>
						Client Commercial Information
					</div>
					<div style={contentPanel}>
						<EditPanel
						title="Main Details"
							componentRows = {mainComponentRows}
						/>
						<div style={contactContainer}>
							<div style={contactHeader}>
								Contacts
								<div style={blueButton} onClick={addNew}>
									Add New
								</div>
							</div>
							{clientCommercialContactDisplay}
						</div>
				</div>
				<div style={progressContainer}>
				<CircularProgress
						color="inherit"
					>
					</CircularProgress>
			</div>
			<div style={editFooter}>
				<div style={editButtonContainer}>
					<div style={editButton} onClick={goSubmit}>
						Save
					</div>
					<div style={editButton} onClick={goBack}>
						Back To Menu
					</div>
				</div>
			</div>
			</div>
			
	
	);
}